import React, { useState } from 'react';
import { useApiCaller } from '../../utils/ApiUtilities';
import { getSuperAdminAdminUrl } from '../../utils/UrlUtilities';
import { buildUpdateAdminPayload } from '../../utils/PayloadUtils';

export default function AdminEditProfileForm({ admin, onUpdated, onCancel }) {
    const [name, setName] = useState(admin.name || '');
    const [isActive, setIsActive] = useState(admin.is_active);
    const [showPasswordSection, setShowPasswordSection] = useState(false);
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const CallApi = useApiCaller();

    const isPasswordValid = (p) =>
        new RegExp(`^(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+\\-=[\\]{};:'",.<>/?]).{8,}$`).test(p);
    const passwordOk = !showPasswordSection || (password && isPasswordValid(password));
    const isValid = name.trim() && passwordOk;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isValid) return;
        setSubmitting(true);
        const payload = buildUpdateAdminPayload({
            name: name !== admin.name ? name.trim() : undefined,
            isActive: isActive !== admin.is_active ? isActive : undefined,
            password: showPasswordSection ? password : undefined,
        });
        const res = await CallApi({
            url: getSuperAdminAdminUrl(admin.id),
            method: 'PATCH',
            payload,
        });
        setSubmitting(false);
        if (res.success && onUpdated) {
            onUpdated(res.data, { passwordChanged: showPasswordSection });
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3">
                <label>Name</label>
                <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
            </div>
            <div className="mb-3">
                <label className="me-2">Email</label>
                <div className="text-muted">{admin.email}</div>
            </div>
            <div className="mb-3 form-check">
                <input
                    type="checkbox"
                    id="adminActive"
                    className="form-check-input"
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="adminActive">
                    Active (uncheck to deactivate — admin will be logged out instantly)
                </label>
            </div>
            <div className="mb-3">
                <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={() => setShowPasswordSection(s => !s)}
                >
                    {showPasswordSection ? 'Cancel password change' : 'Change password'}
                </button>
                {showPasswordSection && (
                    <div className="mt-2">
                        <div className="input-group">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className={`form-control ${password && !isPasswordValid(password) ? 'is-invalid' : ''}`}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="New password"
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword(s => !s)}
                            >
                                {showPassword ? 'Hide' : 'Show'}
                            </button>
                        </div>
                        {password && !isPasswordValid(password) && (
                            <small className="text-danger">
                                Min 8 chars, with uppercase, digit, and special character.
                            </small>
                        )}
                        <small className="text-muted d-block mt-1">
                            Setting a new password will log the admin out of all sessions.
                        </small>
                    </div>
                )}
            </div>
            <div className="d-flex gap-2">
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!isValid || submitting}
                >
                    {submitting ? 'Saving…' : 'Save'}
                </button>
                {onCancel && (
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>
                        Cancel
                    </button>
                )}
            </div>
        </form>
    );
}
